export const DEFAULT = 'default';
export const COMMENT = 'comment';